import type { CatalogSeed } from '../pricing/seedBuilder';

export const componentSkusOf = (seed: CatalogSeed): string[] =>
  [...new Set(seed.rows.map((r) => r.componentSku))];

/** Deduped: mergeSeed keeps every composition version side by side. */
export const productSkusOf = (seed: CatalogSeed): string[] =>
  [...new Set(seed.compositions.map((c) => c.productSku))];
